import React from 'react';
import PropTypes from 'prop-types';
import CreateAPasswordLink from './CreateAPasswordLink';
import CreateAPasswordWrapper from './CreateAPasswordWrapper';

const propTypes = { id: PropTypes.string };
const defaultProps = { id: undefined };

export default function CreateAPasswordModal({ id }) {
  return (
    <div id="create-password-link-wrapper">
      <CreateAPasswordLink id={id} />
      <CreateAPasswordWrapper />
    </div>
  );
}

CreateAPasswordModal.propTypes = propTypes;
CreateAPasswordModal.defaultProps = defaultProps;
